import log from 'uix/logging'

export const tree = {
  tabs: {
    gndo: {
      tabGroup: 'formats',
      datatype: [13, 16, 19],
      parts: ['GndoResource'],
      acl: 'g:admin',
      label: 'DNB',
    },
    gndo_lobid: {
      tabGroup: 'formats',
      datatype: [13, 16, 19],
      parts: ['GndoResourceLobId'],
      acl: 'g:admin',
      label: 'LOBID',
    },
    graph: {
      tabGroup: 'overview',
      parts: ['GndoForcegraph'],
      acl: 'g:admin',
      enabled: ({datatype, treeNode}) =>
        treeNode.nodeType == 'domain:indices' || [2, 1, 0, 3, 13, 16, 19].includes(datatype),
      //~ label: 'Graph',
    },
    map: {
      tabGroup: 'overview',
      parts: ['GndoMap'],
      acl: 'g:debug,g:admin',
      enabled: ({datatype, treeNode}) =>
        treeNode.nodeType == 'domain:indices' || [2, 1, 0, 3, 13, 16, 19].includes(datatype),
      //~ label: 'Graph',
    },
  },
}
